import { render, staticRenderFns } from "./page-component.vue?vue&type=template&id=a42d8b6c"
import script from "./page-component.vue?vue&type=script&lang=js"
export * from "./page-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports